import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axiosInstance from 'src/api/axiosInstance';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import BreadCrumbs from 'src/components/custom-breadcrumbs/breadcrumbs';
import { getCurrentProject, getCurrentServer, getMandEndPoint } from 'src/helper/server-address';
import useNavigateErrorHandler from 'src/hooks/useNavigateErrorHandler';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';
import { fetchEncryptedToken } from 'src/utils/encryptUtils';
import EmployeeNewEditForm from '../employee-new-edit-form';
import EmployeeReplicaForm from '../employeeReplicaForm';


export default function EmployeeReplicaEditView() {
  const token = sessionStorage.getItem('token');
  const settings = useSettingsContext();
  const [currentEmp, setCurrentEmp] = useState(null);
  const [currentEmpExp, setCurrentEmpExp] = useState([]);
  const [currentEmpRef, setCurrentEmpRef] = useState([]);
  const [currentEmpEmrg, setCurrentEmpEmrg] = useState([]);
  const [currentEmpLang, setCurrentEmpLang] = useState([]);
  const [currentEmpWrk, setCurrentEmpWrk] = useState([]);
  const [currentEmpCert, setCurrentEmpCert] = useState([]);
  const [currentEmpVisa, setCurrentEmpVisa] = useState([]);
  const [currentEmpEdu, setCurrentEmpEdu] = useState([]);
  const [currentEmpBank, setCurrentEmpBank] = useState([]);
  const [currentEmpPass, setCurrentEmpPass] = useState([]);
  const [currentEmpFam, setCurrentEmpFam] = useState([]);
  const [currentEmpImpQ, setCurrentEmpImpQ] = useState([]);
  const handleApiError = useNavigateErrorHandler();


  console.log("in the Employee Replica Edit View File....")
  
  const { id } = useParams();

  const location = useLocation();

  const isOnEmployeeForm = location.pathname.includes('/employeeForm');

  const getCand = useCallback(() => {
    axiosInstance
      .get(
        `/rest/employee/external/singleEmpDetails/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setCurrentEmp(res.data.employee);
        setCurrentEmpBank(res.data.empBankData);
        setCurrentEmpCert(res.data.empCertData);
        setCurrentEmpEdu(res.data.empEduData);
        setCurrentEmpEmrg(res.data.empEmrgData);
        setCurrentEmpExp(res.data.empExpData);
        setCurrentEmpFam(res.data.empFamData);
        setCurrentEmpLang(res.data.empLangData);
        setCurrentEmpPass(res.data.empPassData);
        setCurrentEmpRef(res.data.empRefData);
        setCurrentEmpVisa(res.data.empVisaData);
        setCurrentEmpWrk(res.data.empWrkData);
        setCurrentEmpImpQ(res.data.empImpQData);
      }).catch((error) => {
        handleApiError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setCurrentEmpWrk,
    setCurrentEmpVisa,
    setCurrentEmpRef,
    setCurrentEmpPass,
    setCurrentEmpLang,
    setCurrentEmpFam,
    setCurrentEmpExp,
    setCurrentEmpEmrg,
    setCurrentEmpEdu,
    setCurrentEmpCert,
    setCurrentEmpBank,
    setCurrentEmp,
    setCurrentEmpImpQ,
    token,
  ]);

  useEffect(() => {
    getCand();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getCand]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      {console.log("in the Employee Replica View File....")}
      {!isOnEmployeeForm && (
        <BreadCrumbs heading='Edit Employee' />
      )}
      <EmployeeReplicaForm
        currentEmpFam={currentEmpFam}
        currentEmpPass={currentEmpPass}
        currentEmpBank={currentEmpBank}
        currentEmpEdu={currentEmpEdu}
        currentEmpVisa={currentEmpVisa}
        currentEmpCert={currentEmpCert}
        currentEmpWrk={currentEmpWrk}
        currentEmpLang={currentEmpLang}
        currentEmpEmrg={currentEmpEmrg}
        currentEmpRef={currentEmpRef}
        currentEmpExp={currentEmpExp}
        currentEmp={currentEmp}
        currentEmpImpQ={currentEmpImpQ}
      />
    </Container>
  );
}

